import Media from '@/components/media';
import { Header1 } from '@bumble/ui-kit';

import styles from './media-hero.module.scss';

export default function MediaHero({ data }: { data: any }) {
  return (
    <div className={styles.media__hero}>
      <div className={styles.media}>
        <Media
          media={{
            video: {
              desktop: {
                webm: '/love-stories/assets/video/bumble-date-website-header-desktop.webm',
                mp4: '/love-stories/assets/video/bumble-date-website-header-desktop.mp4',
              },
              tablet: {
                webm: '/love-stories/assets/video/bumble-date-website-header-tablet.webm',
                mp4: '/love-stories/assets/video/bumble-date-website-header-tablet.mp4',
              },
              mobile: {
                webm: '/love-stories/assets/video/bumble-date-website-header-mobile.webm',
                mp4: '/love-stories/assets/video/bumble-date-website-header-mobile.mp4',
              },
            },
          }}
          fill={true}
        />
      </div>

      <div className="gradient" />

      {data?.title && (
        <div className={styles.title}>
          <Header1 color="brand">{data?.title}</Header1>
        </div>
      )}
    </div>
  );
}
